<xen-modal size="lg" modal_title="Validate and certifcate" subtitle="Modal subtitle">
  <div xenModalBody style="height: 140px" [formGroup]="form">
    <xen-alert
      [type]="'info'"
      [content]="'You still have <strong>an unfinished case</strong>, are you sure <strong>you want to finish the certification</strong> process anyway?'"
      [icon]="true"
      [icon_snippet]="'fas fa-circle-info'"
      [dismiss]="false"
      [system]="false"
    ></xen-alert>
    <xen-checkbox
      [checked]="false"
      formControlName="checkAgree"
      [indeterminated]="false"
      [disabled]="false"
      [reverse]="false"
      [label]="'Yes, I agree to end the certification'"
    ></xen-checkbox>
  </div>
  <div xenModalFooter class="d-flex gap-4">
    <xen-btn
      (clicked)="close(false)"
      type="flat"
      size="medium"
      label="No, I want to complete the case"
      skin="gray"
    ></xen-btn>
    <xen-btn
      (clicked)="close(true)"
      [disabled]="form.get('checkAgree').value === false"
      type="primary"
      size="medium"
      label="Yes, continue"
    ></xen-btn>
  </div>
</xen-modal>
